var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmeetGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2016_18328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2016_18328)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.66634 13.3332C2.29967 13.3332 1.9859 13.2027 1.72501 12.9418C1.46367 12.6805 1.33301 12.3665 1.33301 11.9998V3.99984C1.33301 3.63317 1.46367 3.31939 1.72501 3.0585C1.9859 2.79717 2.29967 2.6665 2.66634 2.6665H10.6663C11.033 2.6665 11.347 2.79717 11.6083 3.0585C11.8692 3.31939 11.9997 3.63317 11.9997 3.99984V6.99984L14.6663 4.33317V11.6665L11.9997 8.99984V11.9998C11.9997 12.3665 11.8692 12.6805 11.6083 12.9418C11.347 13.2027 11.033 13.3332 10.6663 13.3332H2.66634ZM2.66634 11.9998H10.6663V3.99984H2.66634V11.9998Z",
    fill: "#343434"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmeetGrey);
export default __webpack_public_path__ + "static/media/gmeet_grey.03573447cca65ff425e8c05371ffbdca.svg";
export { ForwardRef as ReactComponent };